// Entry point for the JS bundling system via esbuild
// Converted from legacy Sprockets manifest

// ======================= Core Libraries =========================
// 260507nrai: jQuery globals + migrate (not Bootstrap CSS; folder name avoids confusion)
import $ from './jquery_setup/jquery_and_migrate';

// ======================= Other Libraries =========================
import Rails from '@rails/ujs';
window.Rails = Rails;
Rails.start();

import './vendor/d3/d3.min';

import * as ActiveStorage from "@rails/activestorage";
import { DirectUpload } from "@rails/activestorage";
ActiveStorage.start();

// import * as Turbo from "@hotwired/turbo"
// window.Turbo = Turbo

import './vendor/foundation/foundation.js';
import './vendor/foundation/foundation.dropdown.js';
import './vendor/foundation/foundation.abide.js';
import './vendor/foundation/foundation.accordion.js';
import './vendor/foundation/foundation.alert.js';
import './vendor/foundation/foundation.clearing.js';
import './vendor/foundation/foundation.equalizer.js';
import './vendor/foundation/foundation.interchange.js';
import './vendor/foundation/foundation.joyride.js';
import './vendor/foundation/foundation.magellan.js';
import './vendor/foundation/foundation.offcanvas.js';
import './vendor/foundation/foundation.orbit.js';
import './vendor/foundation/foundation.reveal.js';
import './vendor/foundation/foundation.slider.js';
import './vendor/foundation/foundation.tab.js';
import './vendor/foundation/foundation.tooltip.js';
import './vendor/foundation/foundation.topbar.js';
import './vendor/foundation/foundation.modernizr.js';

// ======================= jQuery Plugins =========================
import './jquery_plugins/jquery.stickytableheaders';
import './jquery_plugins/jquery.tooltipster.min';
import './jquery_plugins/jquery-progresspiesvg-min';
import './jquery_plugins/jquery.offscreen';
import './jquery_plugins/jquery.responsiveTabs.min';
import './jquery_plugins/jquery-ui-effects-bundle.min';
import './jquery_plugins/jquery.cookie';
import './jquery_plugins/jquery.scrollTo.min';
import './jquery_plugins/jquery.tablesorter.js';
import './jquery_plugins/jquery.json-viewer';
import './jquery_plugins/simpleTimeline';
import './jquery_plugins/resize';
import './jquery_plugins/pwstrength-foundation';
import './jquery_plugins/jquery_datetimepicker';

// ======================= Date & Time =========================
import moment from 'moment';
import 'moment/locale/de';
window.moment = moment;
moment.locale('de');

// ======================= Custom JS =========================
import './custom';

// ======================= Editors =========================
// --- TinyMCE (recommended: use <%= tinymce_assets %> in your views)

// 260825nrai: CodeMirror 6 (SQL/Ruby editors). Not exposed as window.CodeMirror (CM5 API).
import { init_code_editors } from './code_editor';

// ======================= Charts & Maps =========================
import Highcharts from 'highcharts';
window.Highcharts = Highcharts;
// import L from 'leaflet'; // Leaflet for maps

// ======================= UI Enhancements =========================
import select2 from "select2";
select2($); 

// ======================= PDFObject =========================
import PDFObject from 'pdfobject';
window.PDFObject = PDFObject;

// 260730nrai: driver.js for docus_drugs product tour (ported from R4 vendor; was require_tree)
import './vendor/driver.js.iife.js';
if (typeof window.driver !== 'function' && window.driver?.js?.driver) {
  window.driver = window.driver.js.driver;
}

// 260722nrai: jsPDF + autotable for client-side table PDFs (e.g. current meds)
import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';
applyPlugin(jsPDF);
window.jspdf = { jsPDF };

// import 'select2/dist/js/i18n/de.js';
// import 'fullcalendar';
// import 'fullcalendar/locales-all';

// ======================= jsSHA =========================
// import 'jssha/sha.js';
// import 'jssha/sha1.js';
// import 'jssha/sha3.js';
// import 'jssha/sha256.js';
// import 'jssha/sha512.js';

// ======================= Froala Editor =========================
import FroalaEditor from './vendor/froala/froala_editor.pkgd.min.js';
window.FroalaEditor = FroalaEditor;
import './vendor/froala/plugins/align.min.js';
import './vendor/froala/plugins/char_counter.min.js';
import './vendor/froala/plugins/code_view.min.js';
import './vendor/froala/plugins/colors.min.js';
import './vendor/froala/plugins/emoticons.min.js';
import './vendor/froala/plugins/file.min.js';
import './vendor/froala/plugins/font_size.min.js';
import './vendor/froala/plugins/fullscreen.min.js';
import './vendor/froala/plugins/help.min.js';
import './vendor/froala/plugins/image.min.js';
import './vendor/froala/plugins/image_manager.min.js';
import './vendor/froala/plugins/inline_class.min.js';
import './vendor/froala/plugins/inline_style.min.js';
import './vendor/froala/plugins/line_breaker.min.js';
import './vendor/froala/plugins/line_height.min.js';
import './vendor/froala/plugins/link.min.js';
import './vendor/froala/plugins/lists.min.js';
import './vendor/froala/plugins/paragraph_format.min.js';
import './vendor/froala/plugins/paragraph_style.min.js';
import './vendor/froala/plugins/table.min.js';
import './vendor/froala/plugins/special_characters.min.js';
import './vendor/froala/plugins/url.min.js';
import './vendor/froala/plugins/video.min.js';

// 260825nrai: Froala HTML-Ansicht als Textarea, ohne CodeMirror 5.
FroalaEditor.DEFAULTS.codeMirror = false;

// ======================= LiveWebDialer =========================
// 260507nrai: After Froala — static SignalR import must not run before earlier imports finish / globals bootstrap.
import './vendor/livewebdialer/jquery.signalR-2.2.0.min.js';
import './vendor/livewebdialer/WebDialerHub.js';
import './vendor/livewebdialer/LiveWebdialerPsynot.js';

import { initVoiceInput } from './voice_input';

// ======================= Third-party Addons =========================
// import 'third_party/embedly.min.js'; // optional
// import 'third_party/image_tui.min.js'; // optional
// import 'third_party/spell_checker.min.js'; // optional

// ======================= Languages / Locales =========================
// import 'wysiwyg/languages/de.js';

// ============ Ensure CSRF Token with each AJAX request ===============
// added 250520nr
$.ajaxSetup({
  beforeSend: function(xhr) {
    const token = $('meta[name="csrf-token"]').attr('content');
    if (token) xhr.setRequestHeader('X-CSRF-Token', token);
  }
});

$(function () {
  $(document).foundation();
  initVoiceInput();
  init_code_editors();
});

// For debugging:
// document.addEventListener('DOMContentLoaded', () => {
//   console.log("✅ JS bundle loaded via ESBuild");
// });
